import React, { useEffect, useState } from "react";
import ViewerTreeElement from "./ViewerTreeElement";
import { Chunk } from "./ViewerTree";
import { useAppSelector, useViewer } from "../../../app/hooks/hooks";
interface ViewerTreeModelProps {
    tree: Chunk;
    modelID: number;
    search: string;
    selectionTrigger: number;
}
function ViewerTreeModel({
    tree,
    modelID,
    search,
    selectionTrigger,
}: ViewerTreeModelProps) {
    const viewer = useViewer();
    const [curTree, setCurTree] = useState<Chunk>(tree);
    const [treeMap, setTreeMap] = useState(new Map<number, number>());
    const [selected, setSelected] = useState(new Set<number>());
    useEffect(() => {
        if (!viewer) return;
        getAllChildren(tree);
        setTreeMap(treeMap);
        viewer?.container.addEventListener("hideTrigger", hideTrigger);
        return () => {
            viewer?.container.removeEventListener("hideTrigger", hideTrigger);
        };
    }, []);
    useEffect(() => {
        hideTrigger();
    }, [viewer?.models[modelID].activeElements.size]);
    useEffect(() => {
        selectTrigger();
    }, [selectionTrigger]);
    const checkHiddenChildren = (chunk: Chunk): boolean => {
        if (!viewer) return false;
        if (chunk.children.length) {
            let check = true;
            for (const child of chunk.children) {
                if (child.children.length) {
                    const curCheck = checkHiddenChildren(child as Chunk);
                    if (!curCheck) {
                        check = false;
                    }
                } else {
                    const curCheck = viewer.models[modelID].activeElements.has(
                        child.id
                    );
                    if (curCheck) {
                        check = false;
                    }
                    (child as Chunk).hidden = !curCheck;
                }
            }
            chunk.hidden = check;
        } else {
            chunk.hidden = !viewer.models[modelID].activeElements.has(chunk.id);
        }
        return chunk.hidden;
    };
    const hideTrigger = () => {
        checkHiddenChildren(curTree);
        setCurTree(structuredClone(curTree));
    };
    const selectTrigger = () => {
        if (!viewer) return;
        const allParents = new Set<number>();
        viewer.selector.selectedElements[modelID].forEach((id) => {
            allParents.add(id);
            let mapId = treeMap.get(id);
            while (mapId) {
                allParents.add(mapId);
                mapId = treeMap.get(mapId);
            }
        });
        setSelected(allParents);
    };

    const getAllChildren = (chunk: Chunk) => {
        for (const child of chunk.children) {
            treeMap.set(child.id, chunk.id);
            getAllChildren(child as Chunk);
        }
    };

    return (
        <ViewerTreeElement
            chunk={curTree}
            modelID={modelID}
            search={search}
            hideTrigger={hideTrigger}
            selected={selected}
            selectTrigger={selectTrigger}
        ></ViewerTreeElement>
    );
}

export default ViewerTreeModel;
